import Vue from 'vue';
import App from './App';
import BootstrapVue from 'bootstrap-vue';
import router from './router';
import { store } from './store';
import '../public/bootstrap.min.css';
import '../public/dashboard.css';

import Breadcrumbs from './components/bread_crumbs';
import VueFeather from 'vue-feather';
import SmartTable from 'vuejs-smart-table';
import VueSweetalert2 from 'vue-sweetalert2';
import Toasted from 'vue-toasted';
import {helper} from '@/services/helper';


// Import Theme scss
import './assets/scss/app.scss'

Vue.use(VueFeather);
Vue.use(BootstrapVue);
Vue.use(SmartTable);
Vue.use(VueSweetalert2);
Vue.use(Toasted,{
  iconPack: 'fontawesome'
});

Vue.component('Breadcrumbs', Breadcrumbs)

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  const token = localStorage.getItem("token")
  
  if (to.meta.requriesAuth) {
    if (token) {
      const userDetail = helper.getUserObject(localStorage.getItem("user"));
      store.commit('user/localUser', userDetail)  
      console.log("token")
      //next()
      // check if route is restricted by role
      if (to.meta.authorize.length && !to.meta.authorize.includes(userDetail.grade)) {
        // role not authorised so redirect to home page
        if (userDetail.grade == "SISWA") {
          return next({ path: '/dashboardsiswa/dashboard' });
        } else {
          return next({ path: '/' });
        }        
      }
    } else {
      console.log("login")
      next({
        name: 'Login'
      })
    }
  }
  next()
})

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  },
  render: h => h(App) 
})

